// Store provides state that are pure ui manipulations

import produce from "immer";
import makeStore from "../../utils/makeStore";
import { ILayoutStore, layoutStoreInitialState } from "./models/LayoutStore";

export enum LayoutStoreActions {
  toggleSidebarOpen = "toggleSidebarOpen",
}

export interface IILayoutStoreAction {
  type: LayoutStoreActions;
}

const toggleSidebarOpen = (draft: ILayoutStore) => {
  draft.isSidebarOpen = !draft.isSidebarOpen;
};

const layoutReducer = (state: ILayoutStore, action: IILayoutStoreAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case LayoutStoreActions.toggleSidebarOpen:
        toggleSidebarOpen(draft);
        break;

      default:
        break;
    }
  });

const [LayoutStoreProvider, useLayoutStore, useLayoutDispatch] = makeStore(
  layoutReducer,
  layoutStoreInitialState,
  "geneial0LayoutStore",
  true
);

export { LayoutStoreProvider, useLayoutStore, useLayoutDispatch };
